import { Cookies } from './'

export default {
	isValidUTMObject (obj) {
		const validData = Object.keys(obj).reduce((acc, prop) => {
			if (obj[prop]) {
				acc[prop] = obj[prop]
			}

			return acc
		}, {})

		return Object.values(validData).length >= 1
	},

	getUTMParams (obj) {
		return {
			campaignName: obj.utm_campaign,
			campaign_2: obj.utm_campaign_2,
			campaign_3: obj.utm_campaign_3,
			source: obj.utm_source,
			source_2: obj.utm_source_2,
			source_3: obj.utm_source_3,
			medium: obj.utm_medium,
			medium_2: obj.utm_medium_2,
			medium_3: obj.utm_medium_3,
			term: obj.utm_term,
			term_2: obj.utm_term_2,
			term_3: obj.utm_term_3,
			content: obj.utm_content,
			content_2: obj.utm_content_2,
			content_3: obj.utm_content_3,
			gaSource: obj.utm_gaSource,
			gaSource_2: obj.utm_gaSource_2,
			gaSource_3: obj.utm_gaSource_3
		}
	},

	getUTMObjectFromQueryString (str) {
		// eslint-disable-next-line prefer-regex-literals
		const pattern = new RegExp('([^?=&]+)(=([^&]*))?', 'g')
		const obj = (str.match(pattern) || []).reduce((acc, item) => {
			const [key, value] = item.split('=')

			acc[key] = value

			return acc
		}, {})

		return this.getUTMParams(obj)
	},

	getUTMCookie () {
		const utmCookie = Cookies.get('user_utms')
		if (utmCookie) {
			const utmStr = unescape(utmCookie)
			const utmObject = JSON.parse(utmStr)
			const cookieUTM = this.getUTMParams(utmObject)

			return this.isValidUTMObject(cookieUTM) ? cookieUTM : null
		}

		return null
	}
}
